module.exports = __webpack_public_path__ + "static/img/img-7.cb27e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-7.png
// module id = UEyc
// module chunks = 1